var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EBEDFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_117_4995",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_117_4995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4402 24.5C21.5557 24.5 19.6625 24.0618 17.7605 23.1855C15.8587 22.3092 14.1113 21.073 12.5183 19.477C10.9254 17.8808 9.69083 16.1333 8.8145 14.2345C7.93817 12.3358 7.5 10.4443 7.5 8.55975C7.5 8.25692 7.6 8.00458 7.8 7.80275C8 7.60092 8.25 7.5 8.55 7.5H11.8115C12.064 7.5 12.2868 7.58242 12.4798 7.74725C12.6727 7.91192 12.7955 8.11542 12.848 8.35775L13.4213 11.3C13.4609 11.573 13.4526 11.8076 13.3963 12.0038C13.3398 12.1999 13.2384 12.3647 13.0923 12.498L10.7827 14.7462C11.1544 15.4269 11.5791 16.0708 12.0567 16.678C12.5342 17.285 13.0512 17.8648 13.6077 18.4173C14.1564 18.9661 14.7397 19.4757 15.3577 19.9462C15.9757 20.4167 16.6431 20.8546 17.3598 21.2598L19.6038 18.9963C19.7603 18.8334 19.9498 18.7193 20.1723 18.6538C20.3946 18.5884 20.6257 18.5724 20.8655 18.6058L23.6423 19.1713C23.8948 19.2379 24.1008 19.3667 24.2605 19.5577C24.4202 19.7487 24.5 19.9654 24.5 20.2078V23.45C24.5 23.75 24.3991 24 24.1973 24.2C23.9954 24.4 23.7431 24.5 23.4402 24.5ZM10.073 13.327L11.8577 11.6193C11.8898 11.5936 11.9106 11.5583 11.9202 11.5135C11.9299 11.4687 11.9283 11.427 11.9155 11.3885L11.4808 9.15375C11.4679 9.10258 11.4455 9.06417 11.4135 9.0385C11.3815 9.01283 11.3398 9 11.2885 9H9.15C9.1115 9 9.07942 9.01283 9.05375 9.0385C9.02825 9.06417 9.0155 9.09625 9.0155 9.13475C9.06667 9.81808 9.1785 10.5122 9.351 11.2173C9.52333 11.9224 9.764 12.6257 10.073 13.327ZM18.773 21.9693C19.4358 22.2783 20.1272 22.5145 20.847 22.678C21.567 22.8413 22.2397 22.9384 22.8652 22.9693C22.9037 22.9693 22.9358 22.9564 22.9615 22.9307C22.9872 22.9051 23 22.873 23 22.8345V20.7308C23 20.6794 22.9872 20.6377 22.9615 20.6058C22.9358 20.5738 22.8974 20.5513 22.8462 20.5385L20.7462 20.1115C20.7077 20.0987 20.6741 20.0971 20.6453 20.1067C20.6164 20.1164 20.5859 20.1372 20.5538 20.1692L18.773 21.9693Z",
    fill: "#384BFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.4260798a5a63fbfb1eaa429dc1b96bbe.svg";
export { ForwardRef as ReactComponent };